import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Portfolio } from '../../../models/portfolio';
import { PortfolioService } from '../../../services/PortfolioService';
import { EditPortfolioDialogComponent } from './edit-portfolio-dialog.component';
import { Router } from '@angular/router';
import { PropertyAbstract } from '../../../models/propertyAbstract';
import { AuthenticationService } from '../../../services/AuthenticationService';


@Component({ standalone: false,
  selector: 'select-portfolio-dialog',
  templateUrl: 'select-portfolio-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SelectPortfolioDialogComponent {
  public title: string= "Portfolio";
  public confirmButtonText = "OK";
  public cancelButtonText = "Cancel";

  public selectForm: FormGroup;

  public portfolioArray?:Portfolio[];
  public portfolio?: Portfolio;
  public currentPropertyPortfolioId?:number;
  public readOnly:boolean=true;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<SelectPortfolioDialogComponent>, public dialog:MatDialog, private portfolioService:PortfolioService, private router:Router, private authService:AuthenticationService) {
    this.selectForm = new FormGroup({
      portfolio: new FormControl<Portfolio|undefined>(undefined, Validators.compose([Validators.required])),
    });
    if(data){
      this.portfolio=data.portfolio;
      this.currentPropertyPortfolioId = data.currentPropertyPortfolioId
      //users who may not edit properties (client users) only view the portfolio, whatever the caller requested
      this.readOnly=data.readOnly || !this.authService.currentUserValue?.canEditProperties;
      if(this.readOnly){
        this.cancelButtonText="OK";
      }
      else{
        this.fetchPortfolios();
        this.title="Select Portfolio";
      }
    }
  }

  private fetchPortfolios(){
    this.portfolioService.getPortfolios().pipe(take(1)).subscribe(r=>this.processPortfoliosResponse(r));
  }

  private processPortfoliosResponse(portfolios:Portfolio[]){
    let noPortfolioOption = new Portfolio();
    noPortfolioOption.name='NONE';
    this.portfolioArray=[noPortfolioOption].concat(portfolios);
    if(this.currentPropertyPortfolioId) this.selectForm.get('portfolio')!.setValue(this.portfolioArray.find(p=>p.id===this.currentPropertyPortfolioId));
    else this.selectForm.get('portfolio')!.setValue(this.portfolioArray[0]);
  }

   public onAddPortfolio(){
      if(this.readOnly) return;
      this.addPortfolioDialog(undefined);
  }

  private addPortfolioDialog(p:Portfolio|undefined){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth=800;
    dialogConfig.data={};

    this.dialog.open(EditPortfolioDialogComponent,  dialogConfig).afterClosed().pipe(take(1)).subscribe(value=>{
        if(value){
          this.currentPropertyPortfolioId=value.id; //form field is set during fetchPortfolios
          this.fetchPortfolios();
          this.selectForm.get('portfolio')!.markAsDirty();
        };
    });
  }

  get selectedPortfolio(){
    return this.readOnly ? this.portfolio : this.selectForm.get('portfolio')!.value;
  }

  get canSubmit(){
    return this.readOnly? true : (this.selectForm.dirty && this.selectForm.valid);
  }

  public onPropertyAbstractClick(pa:PropertyAbstract){
    this.router.navigate(['/account/dashboard/property-master/', pa.id]);
    this.dialogRef.close(undefined);
  }

  public onPropertyIdClick(pa:PropertyAbstract){
    this.router.navigate(['/properties/', pa.id]);
    this.dialogRef.close(undefined);
  }

  public onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

  public onConfirmClick(): void {
    if(this.readOnly){ this.dialogRef.close(undefined); return; }
    this.dialogRef.close(this.selectForm.get('portfolio')!.value);
  }

}

